"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _imageLoader = _interopRequireDefault(require("../image-loader"));
require("./svc-image.css");
var _excluded = ["altText", "className", "flexEmbedWrapperClassName", "flexEmbedWidth", "flexEmbedHeight", "imageClassName", "mini", "placeholderUrl", "placeholderAlt", "shadow", "src", "fallbackClassName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A component for displaying a stored value card image with default (but overwritable) styling.
 *
 * The image itself is bound by an ImageLoader (see the [ImageLoader documentation](/components/images) for more details regarding this component's props),
 */

var SvcImage = function SvcImage(_ref) {
  var altText = _ref.altText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    flexEmbedWrapperClassName = _ref.flexEmbedWrapperClassName,
    _ref$flexEmbedWidth = _ref.flexEmbedWidth,
    flexEmbedWidth = _ref$flexEmbedWidth === void 0 ? 632 : _ref$flexEmbedWidth,
    _ref$flexEmbedHeight = _ref.flexEmbedHeight,
    flexEmbedHeight = _ref$flexEmbedHeight === void 0 ? 398 : _ref$flexEmbedHeight,
    imageClassName = _ref.imageClassName,
    _ref$mini = _ref.mini,
    mini = _ref$mini === void 0 ? false : _ref$mini,
    placeholderUrl = _ref.placeholderUrl,
    placeholderAlt = _ref.placeholderAlt,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? true : _ref$shadow,
    src = _ref.src,
    fallbackClassName = _ref.fallbackClassName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_imageLoader["default"], _extends({
    alt: altText,
    className: (0, _classnames2["default"])(className, {
      'sb-svc-image--standardShadow': shadow && !mini,
      'sb-svc-image--miniShadow': shadow && mini
    }),
    imageOnlyClassName: (0, _classnames2["default"])("block sb-svc-image--image", _defineProperty({}, imageClassName, imageClassName)),
    includeFallback: {
      enabled: true,
      // make sure placeholder corners are rounded too!
      fallbackClassName: fallbackClassName || 'sb-svc-image--image'
    },
    placeholder: {
      src: placeholderUrl,
      alt: placeholderAlt
    },
    src: src,
    wrapInFlex: {
      enabled: true,
      height: flexEmbedHeight,
      width: flexEmbedWidth,
      flexEmbedWrapperClassName: flexEmbedWrapperClassName
    }
  }, otherProps));
};
SvcImage.displayName = 'SvcImage';
SvcImage.propTypes = process.env.NODE_ENV !== "production" ? {
  /** `alt` text for the SVC image */
  altText: _propTypes["default"].string,
  /** Class(es) applied to the image */
  className: _propTypes["default"].string,
  /** `src` attribute for the image */
  src: _propTypes["default"].string,
  /** `src` attribute for the placeholder image */
  placeholderUrl: _propTypes["default"].string,
  /** Provide an `alt` for the placeholder if it conveys meaningful information to users */
  placeholderAlt: _propTypes["default"].string,
  /** Adjusts the styling (mainly the shadow) of the SVC card for use with smaller-than-default `width`s and `height`s */
  mini: _propTypes["default"].bool,
  /** A boolean that determines if the shadow should be shown */
  shadow: _propTypes["default"].bool,
  /** This class applies to the grandest-parent of the image */
  flexEmbedWrapperClassName: _propTypes["default"].string,
  /** The width of the SVC image's FlexEmbed container */
  flexEmbedWidth: _propTypes["default"].number,
  /** The height of the SVC image's FlexEmbed container */
  flexEmbedHeight: _propTypes["default"].number,
  /** This is used to append classes to the imageOnlyClassName prop of the ImageLoader (see imageOnlyClassName within the [ImageLoader documentation](/components/images) for more details) */
  imageClassName: _propTypes["default"].string
} : {};
var _default = exports["default"] = SvcImage;